import merge from 'deep-extend'

// collection of global config values that are merged into each set of environment specific configs
var base = {
  appName: 'BAAT Portal',
  appFullName: 'Build And Agile Tools Self-Service Portal',
  slack: {
    channelId: 'C0JSX3QSZ'
  },
  mentionsIssue: 'BAAT-3625',
  adminGroup: 'Lst-digitaltech.baat',
  oAuth: {
    client_id: 'nike.baat.selfservice',
    response_type: 'id_token token',
    scope: 'profile openid email legacy_username '
  },  
}

var local = merge({
  env: 'local',
  apiUrl: 'http://localhost:8001/',
  oAuth: {
    redirect_uri: window.location.origin,
    authorization: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/authorize'
  }
}, base)

var lab = merge({
  env: 'lab',  
  apiUrl: 'https://us-west-2.toolbox-lab.baat-atlassian-test.nikecloud.com',
  oAuth: {
    redirect_uri: 'https://ssp-lab.preprod.baat-atlassian-test.nikecloud.com',
    authorization: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/authorize'
  }
}, base)

var dev = merge({
  env: 'dev',
  apiUrl: 'https://us-west-2.toolbox-preprod.baat-atlassian-test.nikecloud.com',
  oAuth: {
    redirect_uri: 'https://ssp.preprod.baat-atlassian-test.nikecloud.com',
    authorization: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/authorize'
  }
}, base)

var niketech = merge({
  env: 'prod',
  apiUrl: 'https://us-west-2.toolbox-prod.baat-atlassian-prod.nikecloud.com',
  oAuth: {
    redirect_uri: 'https://baat.niketech.com',
    authorization: 'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7/v1/authorize'
  }
}, base)

var prod = merge({
  env: 'prod',
  apiUrl: 'https://us-west-2.toolbox-prod.baat-atlassian-prod.nikecloud.com',
  oAuth: {
    redirect_uri: 'https://ssp.baat-atlassian-prod.nikecloud.com',
    authorization: 'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7/v1/authorize'
  }
}, base)

// Determine which set of environment configs to use based on the url the site is being accessed via.
let config;
if (window.location.origin.includes('//ssp.baat-atlassian-prod.nikecloud.com')) {
  config = prod;
} else if (window.location.origin.includes('//baat.niketech.com')) {
  config = niketech;
} else if (window.location.origin.includes('//localhost')) {
  config = local;
} else if (window.location.origin.includes('//ssp-lab')) {
  config = lab;
} else {
  config = dev;
}


export default config



// WEBPACK FOOTER //
// ./client/src/config.js